import { SplitButton, Text } from 'shell/components';

const options = [
    { key: 'save', value: 'Save' },
    { key: 'schedule', value: 'Schedule Post' },
    { key: 'publish', value: 'Publish Now' },
];

const SplitButtonDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>SplitButton</Text>
            <SplitButton options={options} onClick={console.log} />
        </>
    );
};

export default SplitButtonDemo;
